// converts a relative index (negative counts from the end) to an index within 0..length, like native methods do
export default function toAbsoluteIndex(value, length, defaultValue) {
  if (defaultValue === void 0) {
    defaultValue = 0;
  }
  if (typeof value === 'undefined') {
    return defaultValue;
  }
  // Math.trunc, which IE 11 lacks
  var number = +value;
  var relative = (number < 0 ? Math.ceil(number) : Math.floor(number)) || 0;
  return relative < 0 ? Math.max(length + relative, 0) : Math.min(relative, length);
}